module.exports = __webpack_public_path__ + "assets/images/aac8c26b4969379b40d05f74e1ee6759.png";